/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

// Images
import humans from "../../assets/projectImages/humans.png";

function PortfolioProjects() {
  const humansData = {
    label: "project #1",
    title: "Humans.AI",
    description:
      "HUMANS is creating an all-in-one platform for AI-based creation and governance with an initial focus on synthetic media.",
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid item xs={12} xl={12}>
        <VuiBox display="flex" flexDirection="column" height="100%">
          <VuiBox display="flex" flexDirection="column" mb="24px">
            <VuiTypography color="white" variant="lg" fontWeight="bold" mb="6px">
              Projects Overview
            </VuiTypography>
            <VuiTypography color="text" variant="button" fontWeight="regular">
              Investig in early projects made it easy by our Community
            </VuiTypography>
          </VuiBox>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <Card>
                <DefaultProjectCard
                  image={humans}
                  label="project #1"
                  title="Humans.AI"
                  description="HUMANS is creating an all-in-one platform for AI-based creation and governance with an initial focus on synthetic media."
                  action={{
                    type: "internal",
                    route: "/portfolio/humans",
                    color: "white",
                    label: "VIEW ALL",
                  }}
                />
              </Card>
            </Grid>
          </Grid>
        </VuiBox>
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}

export default PortfolioProjects;
